import React, { Component } from 'react';
import { Row, Col, FormGroup, FormControl } from 'react-bootstrap';
import { connect } from 'react-redux';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Heading from '../Heading';
import FileUploader from '../FileUploader';
import NavButtons from '../NavButtons';
import TeamOthers from './TeamOthers';

class CreateAgreementStandalone extends Component {
  constructor() {
    super();
    this.state = {
      others: [],
      file: null,
      name: '',
      term: '',
      termination: '',
      paymentSchedule: '',
      territoriesIncluded: '',
      territoriesExcluded: '',
      agreementType: '',
      negotiable: '',
      exclusivity: '',
      comments: '',
    };
  }

  componentWillMount() {
    if (!this.props.team) {
      this.props.router.push('/create-deal');
    }
  }

  componentWillReceiveProps(nextProps) {
    const { status, agreement, dealStatus, deal } = nextProps;

    if (this.props.status === actionTypes.AGREEMENT_CREATE_REQUEST) {
      if (status === actionTypes.AGREEMENT_CREATE_SUCCESS && agreement) {
        this.createDeal(agreement);
      } else if (status === actionTypes.AGREEMENT_CREATE_ERROR) {
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      }
    } else if (this.props.dealStatus === actionTypes.DEAL_CREATE_REQUEST) {
      if (dealStatus === actionTypes.DEAL_CREATE_SUCCESS && deal) {
        this.createInvites(deal);
        this.props.router.push('/agreements');
      } else if (dealStatus === actionTypes.DEAL_CREATE_ERROR) {
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      }
    }
  }

  createDeal(agreement) {
    const { team, profile } = this.props;

    const data = {
      team: team.id,
      user: profile.id,
      agreement: agreement.id,
    };

    this.props.createDeal(data);
  }

  createInvites(deal) {
    const { profile, members } = this.props;
    const { others, comments } = this.state;

    const data = {
      deal: deal.id,
      inviter: profile.id,
      inviter_name: profile.name,
      type: 'member',
      comment: comments,
    };

    let inviteData = [];
    members.forEach((member) => {
      inviteData = [
        ...inviteData,
        {
          ...data,
          invitee: member.user,
          email: member.user_info.email,
          name: member.user_info.name,
        },
      ];
    });

    others.forEach((member) => {
      inviteData = [
        ...inviteData,
        {
          ...data,
          email: member.email,
          name: member.name,
          type: member.type,
        },
      ];
    });

    this.props.createInvite(deal.id, inviteData);

    this.props.createDealUser({
      deal: deal.id,
      user: profile.id,
      type: 'owner',
    });
  }

  handleChange = (e) => {
    this.setState({ [e.target.getAttribute('id')]: e.target.value });
  };

  handleSave() {
    const { team, profile } = this.props;
    const { file, name } = this.state;

    this.props.hideAlert();

    if (name.trim() === '') {
      this.props.alert('error', 'Please name this agreement.');
      return false;
    }

    const data = {
      name,
      team: team.id,
      user: profile.id,
      type: 'thirdparty',
      status: this.state.agreementType,
      negotiable: this.state.negotiable === 'yes',
      exclusivity: this.state.exclusivity,
      term: this.state.term,
      termination: this.state.termination,
      payout_schedule: this.state.paymentSchedule,
      territories_included: this.state.territoriesIncluded,
      territories_excluded: this.state.territoriesExcluded,
      comments: this.state.comments,
    };

    if (file) {
      data.file = file.url;
    }

    this.props.createAgreement(data);
  }

  renderAgreementForm() {
    return (
      <div className="agreement-form">
        <p>
          Provide as much detail as you can about the terms of this agreement
          below and upload the agreement file as well.
        </p>
        <FormGroup>
          <Row>
            <Col sm={4}>
              <select
                id="agreementType"
                value={this.state.agreementType}
                onChange={this.handleChange}
              >
                <option value="">Agreement Type</option>
                <option value="Distribution">Distribution</option>
                <option value="Publishing">Publishing</option>
                <option value="Licensing">Licensing</option>
                <option value="Production">Production</option>
                <option value="Royalty Collection & Administration">
                  Royalty Collection & Administration
                </option>
                <option value="Recording">Recording</option>
                <option value="Management">Management</option>
                <option value="Assignment">Assignment</option>
              </select>
            </Col>
            <Col sm={4}>
              <select
                id="negotiable"
                value={this.state.negotiable}
                onChange={this.handleChange}
              >
                <option value="">Negotiable?</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </Col>
            <Col sm={4}>
              <select
                id="exclusivity"
                value={this.state.exclusivity}
                onChange={this.handleChange}
              >
                <option value="">Exclusivity</option>
                <option value="Exclusive">Exclusive</option>
                <option value="Non-Exclusive">Non-Exclusive</option>
              </select>
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <FormControl
            type="text"
            placeholder="Term"
            id="term"
            value={this.state.term}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup>
          <FormControl
            type="text"
            placeholder="Termination"
            id="termination"
            value={this.state.termination}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup>
          <FormControl
            type="text"
            placeholder="Payment Schedule"
            id="paymentSchedule"
            value={this.state.paymentSchedule}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup>
          <FormControl
            type="text"
            placeholder="Territories Included"
            id="territoriesIncluded"
            value={this.state.territoriesIncluded}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup>
          <FormControl
            type="text"
            placeholder="Territories Excluded"
            id="territoriesExcluded"
            value={this.state.territoriesExcluded}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FileUploader
          onUpload={(file) => this.setState({ file })}
          text="Upload Agreement File"
          fileUpload="uploaded"
        />
      </div>
    );
  }

  render() {
    return (
      <div className="create-agreement">
        <Heading text="New Agreement" />
        <div className="content">
          <form>
            <FormGroup>
              <FormControl
                type="text"
                placeholder="What is the name of this agreement?"
                id="name"
                value={this.state.name}
                onChange={this.handleChange}
              />
            </FormGroup>
            <Row>
              <Col sm={4}>
                <TeamOthers
                  onUpdateOthers={(others) => this.setState({ others })}
                />
              </Col>
              <Col sm={8}>{this.renderAgreementForm()}</Col>
            </Row>
            <div className="comments">
              <div className="subheading">Message to Team</div>
              <FormControl
                id="comments"
                componentClass="textarea"
                value={this.state.message}
                onChange={this.handleChange}
              />
            </div>
          </form>
        </div>
        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.push('/create-deal')}
          />
          <NavButtons direction="end" next={() => this.handleSave()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  team: state.teams.selectedTeam,
  members: state.users.members,
  status: state.agreements.status,
  error: state.agreements.error,
  agreement: state.agreements.selectedAgreement,
  dealStatus: state.deals.status,
  deal: state.deals.selectedDeal,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  createAgreement: (data) => {
    dispatch(actions.createAgreement(data));
  },
  createDeal: (deal) => {
    dispatch(actions.createDeal(deal));
  },
  createInvite: (dealId, invite) => {
    dispatch(actions.createInvite(dealId, invite));
  },
  createDealUser: (dealUser) => {
    dispatch(actions.createDealUser(dealUser));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateAgreementStandalone);



// WEBPACK FOOTER //
// src/components/Agreements/CreateAgreementStandalone.jsx